import { useEffect, useRef, useState } from "react";
import { useTaskContext } from "../../../../context/TaskContext";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useMutation } from "@apollo/client";
import { useClickAway } from "@uidotdev/usehooks";
import { DELETE_CHECKLIST, Read_task_notification, SAVE_UPDATE_CHECKLIST } from "../../../../apollo/Mutations";
import { set_active_task } from "../../../../redux/taskSlice";
import toast from "react-hot-toast";
import { getONLYUSERSDATA } from "../../../../Utils/Common";
import { MdAdd } from "react-icons/md";

export default function Checklist() {

  const { set_tasks } = useTaskContext();
  const { allUsers, user } = useSelector(state => state.message);
  const { active_task } = useSelector(state => state.task);

  const [checkListSearch, setCheckListSearch] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [newCheckText, setNewCheckText] = useState('');

  const dispatch = useDispatch();
  const [checklistFilter, setChecklistFilter] = useState(false);
  const [save_update] = useMutation(SAVE_UPDATE_CHECKLIST);
  const [delete_item] = useMutation(DELETE_CHECKLIST);

  const [loader, setloader] = useState(false)
  const ref = useClickAway(() => {
    setChecklistFilter(false);
  });

  const [read_notification] = useMutation(Read_task_notification, {
    onCompleted: (res) => {
      if (res.read_task_notification.success === 'true') {
        dispatch(set_active_task({ ...active_task, view_checklist: [] }))
        set_tasks(prev => prev.map(m => m._id === active_task?._id ? { ...m, view_checklist: [] } : m))
      }
    }
  });

  useEffect(() => {
    if (active_task && active_task?.view_checklist?.indexOf(user?.id) > -1) {
      read_notification({
        variables: { input: { _id: active_task?._id, type: 'view_checklist' } }
      }); // Read the notification
    }
  }, [active_task, user, read_notification]);

  const [editItemId, setEditItemId] = useState('');
  const [editTitle, setEditTitle] = useState('');
  const [newText, setNewText] = useState("");

  const [filterType, setFilterType] = useState('all'); // Default: Show all
  const [sortType, setSortType] = useState('asc');
  const [searchCheckList, setSearchCheckList] = useState('');

  const selectChecklist = (item) => {
    if (editItemId !== item._id) {
      updateParams({
        _id: item._id,
        status: item.status === 'complete' ? 'incomplete' : 'complete',
      })
    }
  }

  const updateParams = async (prms) => {
    let apires = await save_update({
      variables: {
        input: {
          task_id: active_task?._id,
          ...prms,
        },
      },
    });

    if (apires.data.save_update_checklist.status) {
      toast.success('Checklist updated successfully!');
      dispatch(set_active_task({
        ...active_task,
        checklists: active_task?.checklists.map((item) => item._id === prms._id ? { ...item, [Object.keys(prms)[1]]: prms[Object.keys(prms)[1]] } : item)
      }))
      setEditItemId('');
      setEditTitle('');
    }
  };

  const handleEditItem = (item) => {
    setEditItemId(item._id);
    setEditTitle(item.item_title);
  };

  const updateChecklist = async () => {
    if (editTitle.trim()) {
      updateParams({ _id: editItemId, item_title: editTitle.trim() });
    }
  }

  const handleRemoveItem = async (itemId) => {
    await delete_item({
      variables: {
        input: { _id: itemId },
      },
    });
    dispatch(set_active_task({
      ...active_task,
      checklists: active_task?.checklists?.filter((item) => item._id !== itemId)
    }));
  };

  const handleAddItem = async () => {
    if (newText && !loader) {
      setloader(true);

      const { data } = await save_update({
        variables: {
          input: {
            task_id: active_task?._id,
            item_title: newText,
          },
        },
      });
      if (data.save_update_checklist.status) {

        dispatch(set_active_task({
          ...active_task,
          checklists: [...active_task?.checklists, data.save_update_checklist.data]
        }));
      }

      setNewText('');
      setAdding(false);
      setloader(false);
    }
  };

  const checklistItems = active_task?.checklists ?? [];

  // const filteredChecklists = checklistItems.filter((item) => {
  //   if (filterType === 'created_by_me') {
  //     return item.created_by === user?.id;
  //   } else if (filterType === 'created_by_others') {
  //     return item.created_by !== user?.id;
  //   }
  //   return true;

  // }).filter((item) =>
  //   item.item_title.toLowerCase().includes(searchCheckList.toLowerCase())
  // ).filter(item => showCompleted ? item.status === 'complete' : item.status !== 'complete');


  const sortedChecklists = [...checklistItems].sort((a, b) => {
    if (sortType === 'asc') {
      return a.item_title.localeCompare(b.item_title);
    } else if (sortType === 'desc') {
      return b.item_title.localeCompare(a.item_title);
    }
    return new Date(a.created_at) - new Date(b.created_at);
  });

  // const complete = ((active_task?.checklists?.filter((f) => f.status === 'complete').length / active_task?.checklists.length) * 100).toFixed(0);

  // Export checklist to CSV
  // const exportChecklist = () => {
  //   const csvContent = [
  //     ['Item Title', 'Status', 'Created By', 'Created At'].join(','), // Header row
  //     ...checklistItems.map((item) =>
  //       [
  //         item.item_title,
  //         item.status,
  //         getONLYUSERSDATA(allUsers, item.created_by, 'name'), // Get created_by name
  //         new Date(item.created_at).toLocaleString(),
  //       ].join(',')
  //     ),
  //   ].join('\n');

  //   // Create a blob and trigger a download
  //   const blob = new Blob([csvContent], { type: 'text/csv' });
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = 'checklist.csv';
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  //   setChecklistFilter(false);
  // };


  const contentRef = useRef(null);

  const moveCursorToEnd = () => {
    const el = contentRef.current;
    if (!el) return;

    const range = document.createRange();
    const sel = window.getSelection();
    range.selectNodeContents(el);
    range.collapse(false);
    sel.removeAllRanges();
    sel.addRange(range);
  };

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.innerHTML = newText;
      moveCursorToEnd(); // Only after mounting or value change
    }
  }, [newText]);
  const completed = active_task?.checklists?.filter((f) => f.status === 'complete') // sortedChecklists?.filter((f) => f.status === 'complete')


  const [adding, setAdding] = useState(false);
  // const [newText, setNewText] = useState("");
  const newTextRef = useRef(null);

  useEffect(() => {
    const textarea = newTextRef.current;
    if (textarea) {
      textarea.style.height = "auto";

      const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10);
      const maxHeight = lineHeight * 5;

      const newHeight = Math.min(textarea.scrollHeight, maxHeight);
      textarea.style.height = newHeight + "px";

      // Toggle scrollbar only if needed
      textarea.style.overflowY = textarea.scrollHeight > maxHeight ? "auto" : "hidden";
    }
  }, [newText]);


  // const doneCount = sortedChecklists.filter(i => i.done).length;
  const pct = sortedChecklists.length ? Math.round((completed?.length / sortedChecklists.length) * 100) : 0;

  return (
    <>
      <div className="flex items-center justify-between mb-2">
        {/* <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Checklist</p> */}
        <p className="text-[12px] text-teal-600 dark:text-white">Checklist</p>
        <span className="text-xs text-slate-400">{completed?.length}/{sortedChecklists?.length} done</span>
      </div>
      <div className="h-1 bg-slate-100 rounded-full mb-4">
        <div className="h-1 bg-violet-500 rounded-full transition-all duration-500" style={{ width: `${pct}%` }} />
      </div>
      <div className="border border-border-primary hover:border-border-action rounded-lg p-4">
        {/* grid grid-cols-2 gap-x-10 gap-y-3 */}
        <div className="">
          {/* Add Item Row */}
          {adding ? (
            <div className="col-span-2 flex items-start gap-2">
              <div className="w-[16px] h-[16px] mt-[2px] rounded border border-gray-400 flex-shrink-0" />
              <textarea
                value={newText}
                onChange={(e) => setNewText(e.target.value)}
                onBlur={() => {
                  if (newText.trim()) {

                  } else {
                    setAdding(false);
                    setNewText("");
                  }
                }}
                // onKeyDown={(e) => {
                //   if (e.key === "Enter" && !e.shiftKey) {
                //     e.preventDefault();
                //     handleAdd();
                //   }
                //   if (e.key === "Escape") {
                //     setAdding(false);
                //     setNewText("");
                //   }
                // }}
                autoFocus
                ref={newTextRef}
                placeholder="New item"
                rows={1}
                className="w-full text-sm border-b border-border-primary focus:border-border-focus outline-none bg-transparent resize-none transition-all"
                style={{ overflowY: "hidden" }} // default hidden
              />
              <div>
                <MdAdd className='text-teal-600  text-2xl mr-1 cursor-pointer' onClick={handleAddItem} />
              </div>
            </div>
          ) : (
            <div
              className="flex items-start py-1 px-0 rounded hover:bg-gray-50 dark:hover:bg-transparent transition-colors cursor-pointer"
              onClick={() => setAdding(true)}
            >
              <div className="w-[16px] h-[16px] mt-[0px] rounded border border-border-primary flex-shrink-0" />
              <span className="text-[12px] dark:text-white ml-2 text-teal-600">Add item</span>
            </div>
          )}

          {/* Render Items */}
          {sortedChecklists.map((item) => (
            <div
              key={item._id}
              className="flex items-start py-1 px-0 rounded hover:bg-gray-50 transition-colors dark:hover:text-[#CFEAE6] dark:hover:bg-transparent "
            >
              <input
                type="checkbox"
                id={`item-${item._id}`}
                checked={item.status === 'complete'}
                // onChange={() => handleToggleCheck(item._id)}
                onChange={() => selectChecklist(item)}
                className="hidden"
              />
              <label
                htmlFor={`item-${item._id}`}
                className="flex items-start gap-2 cursor-pointer text-text-body w-full !ml-0"
              >
                <span
                  className={`w-[16px] h-[16px] rounded border ${item.status === 'complete' ? "border-text-headings-blue bg-white" : "border-border-primary bg-white"
                    } flex items-center justify-center transition-all flex-shrink-0`}
                >
                  {item.status === 'complete' && (
                    <svg
                      className="w-[16px] h-[16px] text-teal-600 svgIcon"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={3}
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </span>
                <span
                  className={`text-[12px] break-words flex-1 ${item.status === 'complete' ? "line-through text-teal-600 dark:text-white" : "text-teal-600 dark:text-white"
                    }`}
                >
                  {item.item_title}
                </span>
              </label>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
